import TeamRoleType from "@/constants/TeamRoleType";

export const getRelativeOneOnOneMembers = ( oneOnOne, thisUserId ) => {
	const { members, } = oneOnOne;
	const thisMember = members.find( member => member.personId === thisUserId ) || undefined;
	const otherMember = oneOnOne.members.find( member => member.personId !== thisUserId ) || undefined;
	return { thisMember, otherMember, };
};

export const deriveOneOnOneName = ( oneOnOne, thisUserId ) => {
	const { otherMember, } = getRelativeOneOnOneMembers( oneOnOne, thisUserId );
	return otherMember.name || otherMember.email || "";
};

/**
 * Creates a legacy one-on-one team name for backwards-compatability.
 * Components should use teamUtil.deriveOneOnOneName() for display purposes.
 * @param {Object} oneOnOne
 * @param {Array} oneOnOne.members
 * @returns {String} team name
 */
export const createLegacyOneOnOneTeamName = oneOnOne => {
	const { members, } = oneOnOne;
	let manager = members.find( m => m.role === TeamRoleType.MANAGER );
	let report = members.find( m => m.role === TeamRoleType.REPORT );
	// this is a peer relationship
	if ( !( manager && report ) ) {
		manager = members[ 0 ];
		report = members[ 1 ];
	}
	return `${ manager.email } : ${ report.email }`;
};



// WEBPACK FOOTER //
// ./src/lib/teamUtil.js